// Google Analytics 4 (GA4) helpers.
//
// The gtag.js loader lives in public/index.html so the tag is available as early
// as possible. Automatic page views are disabled there (`send_page_view: false`)
// because this is a single page app: gtag would only ever report the first URL.
// AnalyticsTracker sends one page_view per route change instead.

export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-DRCXHT1929";

// Local development stays out of the reports. Set REACT_APP_GA_DEBUG=true to
// send hits while developing (useful with GA4 DebugView).
const isEnabled =
  process.env.NODE_ENV === "production" ||
  process.env.REACT_APP_GA_DEBUG === "true";

const gtag = (...args) => {
  if (!isEnabled || typeof window.gtag !== "function") return;
  window.gtag(...args);
};

export const trackPageView = () =>
  gtag("event", "page_view", {
    page_location: window.location.href,
    page_title: document.title,
  });

export const trackEvent = (name, params = {}) => gtag("event", name, params);
